import React, { useEffect, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import NotoSansMonoReular from "../../../sale/font/NotoSansMono-Regular-normal";
import NotoSansMonoBold from "../../../sale/font/NotoSansMono-Bold-bold";
import { getOS } from "../../../../../utils/getOs";
import axios from "axios";
import { FormatedSaleData } from "../../../../../utils/print/GlobelSaleData";
import { DownloadIcon, PrinterIcon } from "../../../../../constants/Icons";

const Thermal_1 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
  width = true,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [data, setData] = useState({});
  const globalData = FormatedSaleData(data);
  const { settings } = useAuth();
  const { storeSettings } = usePermission();
  const [terms, setTerms] = useState([]);
  const sizeOptions = [
    { key: "BILL", label: "BILL" },
    { key: "INVOICE", label: "INVOICE" },
  ];
  const os = getOS();
  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handlePrintService = async (pdfBase64, printerName) => {
    try {
      const response = await axios.post(
        "http://127.0.0.1:9164/print/pdf",
        {
          pdfBase64,
          printerName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handlePrintSystem = async (pdfBase64, printerName) => {
    if (os === "Windows") {
      return await handlePrintService(pdfBase64, printerName);
    }
    return false;
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  const cashPaid = (data.cashamount || 0) - (data.cashchange || 0);

  const cardPaid = (data.cardamount || 0) - (data.cardchange || 0);

  const onlinePaid = (data.onlineamount || 0) - (data.onlinechange || 0);

  const upiPaid = (data.upiamount || 0) - (data.upichange || 0);

  const balanceDue = (data.paylateramount || 0) - (data.paylaterchange || 0);

  const convertToGrayScale = (dataUrl) =>
    new Promise((resolve) => {
      const img = new Image();
      img.src = dataUrl;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
          data[i] = avg;
          data[i + 1] = avg;
          data[i + 2] = avg;
        }

        ctx.putImageData(imageData, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
    });

  const isIGST =
    globalData.salefrom?.statecode &&
    globalData.saleto?.statecode &&
    globalData.salefrom.statecode !== globalData.saleto.statecode;

  const taxRows = globalData.saleitems?.reduce((acc, product) => {
    const taxPercentage = product?.taxpercentage || 0;
    const taxAmount = product?.lineTotalTaxAmount || 0;
    const basePrice = product?.lineTotalBasePrice || 0;
    if (!acc[taxPercentage]) {
      acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
    }
    acc[taxPercentage].basePrice += basePrice;
    if (isIGST) {
      acc[taxPercentage].igst += taxAmount;
    } else {
      acc[taxPercentage].sgst += taxAmount / 2;
      acc[taxPercentage].cgst += taxAmount / 2;
    }
    return acc;
  }, {});

  const generate3InchinvoiceReceipt = async () => {
    const mm = (pt) => pt / 2.83465;
    const taxRows1 = globalData.saleitems;
    const itemHeight = globalData.saleitems.length * mm(45); // Approx 45pt per item row
    const taxHeight = Object.keys(taxRows1).length * mm(25); //25
    const footerHeight = mm(250); // Total for branding, thank you, and payment boxes
    const headerHeight = mm(250); // Total for logo, store info, and invoice details

    // Total dynamic height with a small buffer
    const dynamicHeight = headerHeight + itemHeight + taxHeight + footerHeight;
    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: [74, dynamicHeight + mm(30)],
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    let y = mm(16);

    const isIGST =
      globalData.salefrom?.statecode &&
      globalData.saleto?.statecode &&
      globalData.salefrom.statecode !== globalData.saleto.statecode;

    const taxRows = globalData.saleitems?.reduce((acc, product) => {
      const taxPercentage = product.taxpercentage || 0;
      const taxAmount = product.lineTotalTaxAmount || 0;
      const basePrice = product.lineTotalBasePrice || 0;
      if (!acc[taxPercentage]) {
        acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
      }
      acc[taxPercentage].basePrice += basePrice;
      if (isIGST) {
        acc[taxPercentage].igst += taxAmount;
      } else {
        acc[taxPercentage].sgst += taxAmount / 2;
        acc[taxPercentage].cgst += taxAmount / 2;
      }
      return acc;
    }, {});

    const checkPageBreak = (doc, y, buffer = mm(20)) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      if (y + buffer >= pageHeight) {
        doc.addPage();
        return mm(14); // reset y to top margin for new page
      }
      return y;
    };

    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";

    if (imagePath) {
      try {
        // Step 1: Convert image URL to base64
        const response = await fetch(imagePath, { mode: "cors" });
        const blob = await response.blob();
        let base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Step 2: Convert to grayscale
        base64 = await convertToGrayScale(base64);

        // Step 3: Get natural dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Step 4: Resize to fit dynamically within maxWidth and maxHeight
        const maxWidth = mm(65); // maximum width in pt for 3-inch receipt
        const maxHeight = mm(40); // maximum height in pt
        const widthRatio = maxWidth / naturalWidth;
        const heightRatio = maxHeight / naturalHeight;
        const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

        const imgWidth = naturalWidth * ratio;
        const imgHeight = naturalHeight * ratio;

        // Step 5: Center the logo
        const logoX = (pageWidth - imgWidth) / 2;

        doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

        y += imgHeight + mm(10); // spacing after logo
      } catch (err) {
        console.warn("Logo failed to load:", err);
      }
    }

    const invoiceTitle =
      globalData.status === "CANCELLED"
        ? "CANCELLED TAX INVOICE"
        : "TAX INVOICE";

    doc
      .setFont("NotoSansMono-Bold", "bold")
      .setFontSize(10)
      .text(invoiceTitle, pageWidth / 2, y, { align: "center" });
    y += mm(13);

    doc.setFont("NotoSansMono-Bold", "bold").setFontSize(11);
    const storeTitle = settings?.saleProfileData?.title || "Store";
    const wrappedStoreTitle = doc.splitTextToSize(
      storeTitle,
      pageWidth - mm(20)
    );
    wrappedStoreTitle.forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += mm(10);
    });

    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(8);
    if (settings?.saleProfileData?.phone) {
      doc.text(`Ph:${settings?.saleProfileData?.phone}`, pageWidth / 2, y, {
        align: "center",
      });
      y += mm(8);
    }

    const seller = settings?.saleProfileData;
    const sellerAddressParts = [
      seller?.addressline1,
      [seller?.state, seller?.district, seller?.country]
        .filter(Boolean)
        .join(", "),
      seller?.pincode ? `- ${seller?.pincode}` : null,
    ].filter(Boolean);

    doc
      .splitTextToSize(sellerAddressParts.join(", "), pageWidth - mm(20))
      .forEach((line) => {
        doc.text(line, pageWidth / 2, y, { align: "center" });
        y += mm(8);
      });

    if (seller?.email) {
      doc.text(`Email: ${seller.email}`, pageWidth / 2, y, { align: "center" });
      y += mm(8);
    }
    doc.text(`GST: ${seller?.gstnumber || ""}`, pageWidth / 2, y, {
      align: "center",
    });
    y += mm(6);
    doc.setDrawColor(0);
    doc.setLineDash([mm(1), mm(1)]);
    doc.line(mm(5), y, pageWidth - mm(5), y);
    doc.setLineDash([]);
    y += mm(12);

    const { date, time } = saleTime;
    const labelX = mm(5); // Left-aligned label start
    const colonX = mm(65); // Colon aligned at this point
    const valueX = mm(70); // Value starts after colon
    const lineHeight = mm(8);
    const drawRowWithColonAligned = (label, value, yPos, isBold = false) => {
      const font = isBold ? "NotoSansMono-Bold" : "NotoSansMono-Regular";
      doc.setFont(font, isBold ? "bold" : "normal").setFontSize(8);
      doc.text(label, labelX, yPos);
      doc.text(":", colonX, yPos);
      doc.text(value, valueX, yPos);
    };
    drawRowWithColonAligned("Invoice No", `${globalData.saleno}`, y);
    y += lineHeight;
    drawRowWithColonAligned("Date", `${date}, ${time}`, y);
    y += lineHeight;
    drawRowWithColonAligned(
      "Amount",
      `₹${CurrencyConverter.toCurrency(globalData.grandtotal || 0, "INR")}`,
      y,
      true
    );
    y += mm(6);
    doc.setDrawColor(0);
    doc.setLineDash([mm(1), mm(1)]);
    doc.line(mm(5), y, pageWidth - mm(5), y);
    y += mm(11);

    const buyer = globalData.saleto;
    const hasBuyerInfo =
      buyer &&
      (buyer?.name ||
        buyer?.phone ||
        buyer?.addressline1 ||
        buyer?.email ||
        buyer?.gstnumber ||
        buyer?.pannumber ||
        buyer?.cinnumber);

    if (hasBuyerInfo) {
      doc.setFont("NotoSansMono-Regular", "normal").setFontSize(8);
      doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
      y += mm(9);

      if (buyer.name) {
        doc.text(`${buyer.name}`, mm(10), y);
        y += mm(8);
      }
      if (buyer.phone) {
        doc.text(`Ph: ${buyer.phone}`, mm(10), y);
        y += mm(8);
      }

      const addressParts = [
        buyer.addressline1,
        [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
        buyer.pincode ? `- ${buyer.pincode}` : null,
      ].filter(Boolean);

      doc
        .splitTextToSize(addressParts.join(", "), pageWidth - mm(20))
        .forEach((line) => {
          doc.text(line, mm(10), y);
          y += mm(8);
        });

      if (buyer.email) {
        doc.text(`Email: ${buyer.email}`, mm(10), y);
        y += mm(8);
      }
      if (buyer.gstnumber) {
        doc.text(`GST: ${buyer.gstnumber}`, mm(10), y);
        y += mm(8);
      }
      if (buyer.pannumber) {
        doc.text(`PAN: ${buyer.pannumber}`, mm(10), y);
        y += mm(8);
      }
      if (buyer.cinnumber) {
        doc.text(`CIN: ${buyer.cinnumber}`, mm(10), y);
        y += mm(5);
      }
      doc.setDrawColor(0);
      doc.setLineDash([mm(1), mm(1)]);
      doc.line(mm(5), y, pageWidth - mm(5), y);
      doc.setLineDash([]);
      y += mm(4);
    }
    const itemRows = [
      [
        {
          content: "",
          colSpan: 4,
          styles: {
            fontSize: 2,
            lineWidth: 0,
            halign: "center",
          },
        },
      ],
      // Actual item rows
      ...globalData.saleitems.flatMap((item) => {
        const rows = [];

        // Title row
        rows.push([
          {
            content: item.title,
            colSpan: 4,
            styles: {
              fontSize: 8,
              fontStyle: "normal",
              font: "NotoSansMono-Regular",
            },
          },
        ]);

        // Note row (only if present and imode = PRODUCT)
        // if (item.imode === "PRODUCT" && item.note) {
        //   rows.push([
        //     {
        //       content: `(${item.note})`,
        //       colSpan: 4,
        //       styles: {
        //         fontSize: 5,
        //         textColor: [100, 100, 100],
        //         fontStyle: "normal",
        //       },
        //     },
        //   ]);
        // }

        // Price row
        rows.push([
          "",
          `₹${item.soldprice}`,
          `${item.quantity} ${(() => {
            const unitCode = item?.isSecondaryUnit
              ? item?.unitConfig?.secondaryUnitCode
              : item?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          `₹${item.lineTotalSoldPrice}`,
        ]);

        return rows;
      }),
    ];

    autoTable(doc, {
      startY: y,
      styles: {
        cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      },
      head: [
        [
          {
            content: "Item",
            colSpan: 4,
            styles: {
              halign: "left",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
        ],
        [
          { content: "", styles: { cellPadding: 0 } },
          {
            content: "Rate",
            styles: {
              halign: "center",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
          {
            content: "Qty",
            styles: {
              halign: "center",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
          {
            content: "Total",
            styles: {
              halign: "right",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
        ],
      ],
      body: itemRows,
      theme: "plain",
      styles: {
        fontSize: 8,
        cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
        lineWidth: 0,
        font: "NotoSansMono-Regular",
        fontStyle: "normal",
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "center" },
        2: { halign: "center" },
        3: { halign: "right" },
      },
      margin: { left: 0, right: mm(5) },
      didDrawCell: (data) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const left = 0;
        const right = pageWidth - mm(5);
        // Bottom dotted line after the second header row ("Rate Qty Total")
        if (
          data.row.section === "head" &&
          data.row.index === 1 &&
          data.column.index === 3
        ) {
          const bottom = data.cell.y + data.cell.height + mm(2);
          doc.setLineDash([mm(1), mm(1)]);
          doc.setDrawColor(0);
          doc.line(left, bottom, right, bottom);
          // doc.setLineDash([]);
        }
        // Bottom dotted line after last row
        if (
          data.row.section === "body" &&
          data.row.index === itemRows.length - 1 &&
          data.column.index === 0
        ) {
          const bottom = data.cell.y + data.cell.height + mm(2);
          doc.setLineDash([mm(1), mm(1)]);
          doc.setDrawColor(0);
          doc.line(left, bottom, right, bottom);
          doc.setLineDash([]);
        }
      },
    });
    y = doc.lastAutoTable.finalY + mm(10);
    // y = checkPageBreak(doc, y);
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(7);
    doc.text(`Total Item: ${globalData.totalItems}`, 0, y);
    y += mm(10);
    doc.setFont("NotoSansMono-Bold", "bold").setFontSize(9);
    doc.text(`Grand Total: ₹${globalData.grandtotal}`, 0, y, { align: "left" });
    y += mm(5);
    // const itemRows = [
    //   [
    //     {
    //       content: "",
    //       colSpan: 4,
    //       styles: {
    //         fontSize: 9,
    //         // cellPadding: 2,
    //         lineWidth: 0,
    //         halign: "center",
    //       },
    //     },
    //   ],
    //   ...data.saleitems.flatMap((item) => {
    //     const rows = [];

    //     // Title + Note in single line
    //     let titleWithNote = item.title;
    //     if (item.imode === "PRODUCT" && item.note) {
    //       titleWithNote += ` (${item.note})`;
    //     }

    //     rows.push([
    //       {
    //         content: titleWithNote,
    //         colSpan: 4,
    //       },
    //     ]);

    //     // Price row
    //     rows.push([
    //       "",
    //       `₹${CurrencyConverter.toCurrency(item.soldprice || 0, "INR")}`,
    //       `${item.quantity}`,
    //       `₹${CurrencyConverter.toCurrency(
    //         item.lineTotalSoldPrice || 0,
    //         "INR",
    //       )}`,
    //     ]);

    //     return rows;
    //   }),
    // ];

    // autoTable(doc, {
    //   startY: y,
    //   pageBreak: "auto",
    //   styles:{
    //     cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
    //   },
    //   head: [
    //     [
    //       {
    //         content: "Item",
    //         colSpan: 4,
    //         styles: { halign: "left", fontStyle: "bold", font: "NotoSansMono-Bold" },
    //       },
    //     ],
    //     [
    //       { content: "", styles: { cellPadding: 0 } },
    //       {
    //         content: "Rate",
    //         styles: { halign: "center", fontStyle: "bold", font: "NotoSansMono-Bold" },
    //       },
    //       {
    //         content: "Qty",
    //         styles: { halign: "center", fontStyle: "bold", font: "NotoSansMono-Bold" },
    //       },
    //       {
    //         content: "Total",
    //         styles: { halign: "right", fontStyle: "bold", font: "NotoSansMono-Bold" },
    //       },
    //     ],
    //   ],
    //   body: itemRows,
    //   theme: "plain",
    //   styles: {
    //     fontSize: 12,
    //     styles:{
    //       cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
    //     },
    //     lineWidth: 0,
    //     font: "NotoSansMono-Regular",
    //     fontStyle: "normal",
    //   },
    //   columnStyles: {
    //     0: { halign: "left" },
    //     1: { halign: "center" },
    //     2: { halign: "center" },
    //     3: { halign: "right" },
    //   },
    //   margin: { left: mm(5), right: mm(5) },
    //   didDrawCell: (data) => {
    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     const left = mm(5);
    //     const right = pageWidth - mm(5);
    //     // Bottom dotted line after the second header row ("Rate Qty Total")
    //     if (
    //       data.row.section === "head" &&
    //       data.row.index === 1 &&
    //       data.column.index === 3
    //     ) {
    //       const bottom = data.cell.y + data.cell.height + 2;
    //       doc.setDrawColor(0);
    //       doc.setLineDash([mm(1), mm(1)]);
    //       doc.line(left, bottom, right, bottom);
    //       doc.setLineDash([]);
    //     }
    //     // Bottom dotted line after last row
    //     if (
    //       data.row.section === "body" &&
    //       data.row.index === itemRows.length - 1 &&
    //       data.column.index === 0
    //     ) {
    //       const bottom = data.cell.y + data.cell.height + mm(2);
    //       doc.setDrawColor(0);
    //       doc.setLineDash([mm(1), mm(1)]);
    //       doc.line(left, bottom, right, bottom);
    //       doc.setLineDash([]);
    //     }
    //   },
    // });

    // y = doc.lastAutoTable.finalY + mm(20);
    // // y = checkPageBreak(doc, y);
    // doc.setFont("NotoSansMono-Regular", "normal");
    // doc.setFontSize(10);
    // doc.text(`Total Item: ${data.totalItems}`, mm(5), y);
    // y += mm(15);

    // doc.setFont("NotoSansMono-Bold", "bold").setFontSize(14);
    // doc.text(
    //   `Total Amount: ₹${CurrencyConverter.toCurrency(
    //     data.grandtotal || 0,
    //     "INR",
    //   )}.00`,
    //   mm(5),
    //   y,
    // );
    // y += mm(12);

    doc.setLineDash([mm(1), mm(1)]);
    doc.setDrawColor(0);
    doc.line(mm(7), y, pageWidth - mm(7), y);
    doc.setLineDash([]);
    y += mm(11);

    // y = checkPageBreak(doc, y);
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
    if (globalData.totaldiscount > 0) {
      doc.text("**** YOU SAVED ****", pageWidth / 2, y, { align: "center" });
      y += mm(10);
    }
    if (globalData.totaldiscount > 0) {
      doc.text(`₹${globalData.totaldiscount}`, pageWidth / 2, y, {
        align: "center",
      });
    }
    y += mm(10);
    // y = checkPageBreak(doc, y);
    // TAX SUMMARY
    const taxHead = isIGST
      ? [["Tax", "Amount", "IGST"]]
      : [["Tax", "Amount", "SGST", "CGST"]];

    const taxBody = Object.entries(taxRows)
      .filter(([percent]) => parseFloat(percent) > 0)
      .map(([percent, t]) =>
        isIGST
          ? [`${percent}%`, `₹${t.basePrice}`, `₹${t.igst}`]
          : [`${percent}%`, `₹${t.basePrice}`, `₹${t.sgst}`, `₹${t.cgst}`]
      );

    if (taxBody.length > 0) {
      autoTable(doc, {
        startY: y,
        pageBreak: "auto",
        head: [
          taxHead[0].map((cell, colIndex) => ({
            content: cell,
            styles: {
              font: "NotoSansMono-Regular",
              fontStyle: "normal",
              fontSize: 8,
              halign: colIndex === 0 ? "left" : "right",
            },
          })),
        ],
        body: taxBody.map((row) =>
          row.map((cell, colIndex) => ({
            content: cell,
            styles: {
              font: "NotoSansMono-Regular",
              fontStyle: "normal",
              fontSize: 8,
              halign: colIndex === 0 ? "left" : "right",
            },
          }))
        ),
        theme: "plain",
        styles: {
          font: "NotoSansMono-Regular",
          fontStyle: "normal",
          fontSize: 8,
          cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
          lineWidth: 0,
        },
        margin: { left: mm(5), right: mm(5) },
        didDrawCell: (data) => {
          const pageWidth = doc.internal.pageSize.getWidth();

          if (
            data.row.section === "head" &&
            data.row.index === 0 &&
            data.column.index === 0
          ) {
            const top = data.cell.y - 2;
            doc.setLineDash([mm(1), mm(1)]);
            doc.setDrawColor(0);
            doc.line(mm(5), top, pageWidth - mm(5), top);
          }

          const isLastTaxRow =
            data.row.section === "body" &&
            data.row.index === taxBody.length - 1;

          if (isLastTaxRow && data.column.index === 0) {
            const bottom = data.cell.y + data.cell.height + mm(2);
            doc.setLineDash([mm(1), mm(1)]);
            doc.setDrawColor(0);
            doc.line(mm(5), bottom, pageWidth - mm(5), bottom);
            doc.setLineDash([]);
          }
        },
      });
      y = doc.lastAutoTable.finalY + mm(13);
    }
    // y = checkPageBreak(doc, y);
    if (globalData.totaltaxamount > 0) {
      doc.setFontSize(9);
      doc.text("Total Tax", mm(5), y);
      doc.text(`₹${globalData.totaltaxamount}`, pageWidth - mm(5), y, {
        align: "right",
      });
      y += mm(8);
    }
    // y = checkPageBreak(doc, y);

    const payLabelX = mm(8); // left label
    const payColonX = mm(72); // aligned colon
    const payValueX = mm(78); // value starts just after :

    const drawPaymentRow = (label, amount, isBold = false) => {
      if (Number(amount) > 0) {
        // y = checkPageBreak(doc, y);

        doc.setFont(
          isBold ? "NotoSansMono-Bold" : "NotoSansMono-Regular",
          isBold ? "bold" : "normal"
        );
        doc.setFontSize(9);

        doc.text(label, payLabelX, y);
        doc.text(":", payColonX, y);
        doc.text(`₹${amount}`, payValueX, y);

        y += mm(9);
      }
    };

    // -------- PAYMENT MODE HEADER --------
    doc.setDrawColor(0);
    doc.setLineDash([mm(1), mm(1)]);
    doc.line(mm(5), y, pageWidth - mm(5), y);
    doc.setLineDash([]);
    y += mm(13);

    doc.setFont("NotoSansMono-Bold", "bold").setFontSize(8);
    doc.text("PAYMENT MODE", pageWidth / 2, y, { align: "center" });
    y += mm(14);

    // -------- PAYMENT VALUES --------
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(8);

    // Adjust values
    const cashPaid = (data.cashamount || 0) - (data.cashchange || 0);

    const cardPaid = (data.cardamount || 0) - (data.cardchange || 0);

    const onlinePaid = (data.onlineamount || 0) - (data.onlinechange || 0);

    const upiPaid = (data.upiamount || 0) - (data.upichange || 0);

    const balanceDue = (data.paylateramount || 0) - (data.paylaterchange || 0);

    // Draw rows only if > 0
    drawPaymentRow("Cash", globalData?.cashPaid);
    drawPaymentRow("Card", globalData?.cardPaid);
    drawPaymentRow("Online Pay", globalData.onlinePaid);
    drawPaymentRow("UPI", globalData?.upiPaid);

    // -------- BALANCE DUE --------
    if (globalData?.balanceDue > 0) {
      // y += 6;
      drawPaymentRow("Balance Due", globalData?.balanceDue, true);
    }

    // -------- FOOTER LINE --------
    y -= mm(4);
    doc.setDrawColor(0);
    doc.setLineDash([mm(1), mm(1)]);
    doc.line(mm(5), y, pageWidth - mm(5), y);
    doc.setLineDash([]);
    y += mm(12);
    doc.text("Thank you for your purchase!", pageWidth / 2, y, {
      align: "center",
    });
    y += mm(12);
    doc.setFont("NotoSansMono-Bold", "bold");
    doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
    if (storeSettings?.negobillBranding) {
      y += mm(11);
      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text("Powered By", pageWidth / 2, y, { align: "center" });
      y += mm(11);
      doc.setFontSize(8);
      const sitePrefix = "www.";
      const siteBold = "NegoBill";
      const siteSuffix = ".com";
      const prefixWidth = doc.getTextWidth(sitePrefix);
      const boldWidth = doc.getTextWidth(siteBold);
      const suffixWidth = doc.getTextWidth(siteSuffix);
      const totalWidth = prefixWidth + boldWidth + suffixWidth;
      const startX = (pageWidth - totalWidth) / 2;

      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text(sitePrefix, startX, y);
      doc.setFont("NotoSansMono-Bold", "bold");
      doc.text(siteBold, startX + prefixWidth, y);
      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text(siteSuffix, startX + prefixWidth + boldWidth, y);
      y += mm(20);
    }
    // setPrint(false);
    return doc;
  };

  const generate4InchBillReceipt = async () => {
    const doc = new jsPDF({
      unit: "pt",
      format: [288, 1000],
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    let y = 18;

    const checkPageBreak = (doc, y, buffer = 20) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      if (y + buffer >= pageHeight) {
        doc.addPage();
        return 14; // reset y to top margin for new page
      }
      return y;
    };

    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";

    if (imagePath) {
      try {
        // Step 1: Convert image URL to base64
        const response = await fetch(imagePath, { mode: "cors" });
        const blob = await response.blob();
        let base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Step 2: Convert to grayscale
        base64 = await convertToGrayScale(base64);

        // Step 3: Get natural dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Step 4: Resize to fit dynamically within maxWidth and maxHeight
        const maxWidth = 80; // maximum width in pt for 3-inch receipt
        const maxHeight = 40; // maximum height in pt
        const widthRatio = maxWidth / naturalWidth;
        const heightRatio = maxHeight / naturalHeight;
        const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

        const imgWidth = naturalWidth * ratio;
        const imgHeight = naturalHeight * ratio;

        // Step 5: Center the logo
        const logoX = (pageWidth - imgWidth) / 2;

        doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

        y += imgHeight + 20; // spacing after logo
      } catch (err) {
        console.warn("Logo failed to load:", err);
      }
    }

    // Header
    const invoiceTitle =
      data.status === "CANCELLED" ? "CANCELLED BILL RECIEPT" : "BILL RECIEPT";

    doc
      .setFont("NotoSansMono-Bold", "bold")
      .setFontSize(16)
      .text(invoiceTitle, pageWidth / 2, y, { align: "center" });
    y += 18;

    doc.setFontSize(14);
    const storeTitle = data.salefrom?.title || "Store";
    doc.splitTextToSize(storeTitle, pageWidth - 30).forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 16;
    });

    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);
    if (data.salefrom?.phone) {
      doc.text(`Ph: ${data.salefrom.phone}`, pageWidth / 2, y, {
        align: "center",
      });
      y += 16;
    }

    const seller = data.salefrom;
    const sellerAddressParts = [
      seller?.addressline1,
      [seller?.state, seller?.district, seller?.country]
        .filter(Boolean)
        .join(", "),
      seller?.pincode ? `- ${seller?.pincode}` : null,
    ].filter(Boolean);

    doc
      .splitTextToSize(sellerAddressParts.join(", "), pageWidth - 30)
      .forEach((line) => {
        doc.text(line, pageWidth / 2, y, { align: "center" });
        y += 16;
      });

    if (seller?.email) {
      doc.text(`Email: ${seller?.email || ""}`, pageWidth / 2, y, {
        align: "center",
      });
      y += 16;
    }

    doc.setLineDash([1], 0);
    doc.line(8, y, pageWidth - 8, y);
    doc.setLineDash([]);
    y += 16;

    const { date, time } = saleTime;
    const labelX = 8; // Left-aligned label start
    const colonX = 110; // Colon aligned at this point
    const valueX = 120; // Value starts after colon
    const lineHeight = 17;
    const drawRowWithColonAligned = (label, value, yPos, isBold = false) => {
      const font = isBold ? "NotoSansMono-Bold" : "NotoSansMono-Regular";
      doc.setFont(font, isBold ? "bold" : "normal").setFontSize(15);
      doc.text(label, labelX, yPos);
      doc.text(":", colonX, yPos);
      doc.text(value, valueX, yPos);
    };
    drawRowWithColonAligned("Bill No", `${data.saleno}`, y);
    y += lineHeight + 2;
    drawRowWithColonAligned("Date", `${date}, ${time}`, y);
    y += lineHeight + 6;
    drawRowWithColonAligned(
      "Total Amount",
      `₹${CurrencyConverter.toCurrency(data.grandtotal || 0, "INR")}`,
      y,
      true
    );
    y += 12;

    doc.setLineDash([1], 0);
    doc.line(8, y, pageWidth - 8, y);
    y += 16;

    const buyer = data.saleto;
    const hasBuyerInfo =
      buyer &&
      (buyer?.name ||
        buyer?.phone ||
        buyer?.addressline1 ||
        buyer?.email ||
        buyer?.gstnumber ||
        buyer?.pannumber ||
        buyer?.cinnumber);

    if (hasBuyerInfo) {
      doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);
      doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
      y += 18;

      if (buyer.name) {
        doc.text(`${buyer.name}`, 10, y);
        y += 16;
      }
      if (buyer.phone) {
        doc.text(`Ph: ${buyer.phone}`, 10, y);
        y += 16;
      }

      const addressParts = [
        buyer.addressline1,
        [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
        buyer.pincode ? `- ${buyer.pincode}` : null,
      ].filter(Boolean);

      doc
        .splitTextToSize(addressParts.join(", "), pageWidth - 20)
        .forEach((line) => {
          doc.text(line, 11, y);
          y += 16;
        });

      if (buyer.email) {
        doc.text(`Email: ${buyer.email}`, 10, y);
        y += 16;
      }
      doc.setLineDash([1], 0);
      doc.line(8, y, pageWidth - 8, y);
      doc.setLineDash([]);
      y += 12;
    }

    const itemRows = [
      [
        {
          content: "",
          colSpan: 4,
          styles: {
            fontSize: 14,
            cellPadding: 2,
            lineWidth: 0,
            halign: "center",
          },
        },
      ],
      ...data.saleitems.flatMap((item) => {
        const rows = [];

        // Title + Note in single line
        let titleWithNote = item.title;
        if (item.imode === "PRODUCT" && item.note) {
          titleWithNote += ` (${item.note})`;
        }

        rows.push([
          {
            content: titleWithNote,
            colSpan: 4,
          },
        ]);

        // Price row
        rows.push([
          "",
          `₹${CurrencyConverter.toCurrency(item.soldprice || 0, "INR")}`,
          `${item.quantity} ${
            (() => {
              const unitCode = item?.isSecondaryUnit
                ? (item?.unitConfig?.secondaryUnitCode ||"")
                : (item?.unitConfig?.primaryUnitCode || "");
              return unitCode||"" ;
            })()
          }`,
          `₹${CurrencyConverter.toCurrency(
            item.lineTotalSoldPrice || 0,
            "INR"
          )}`,
        ]);

        return rows;
      }),
    ];

    autoTable(doc, {
      startY: y,
      head: [
        [
          {
            content: "Item",
            colSpan: 4,
            styles: {
              halign: "left",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
        ],
        [
          { content: "", styles: { cellPadding: 0 } },
          {
            content: "Rate",
            styles: {
              halign: "center",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
          {
            content: "Qty",
            styles: {
              halign: "center",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
          {
            content: "Total",
            styles: {
              halign: "right",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
        ],
      ],
      body: itemRows,
      theme: "plain",
      styles: {
        fontSize: 14,
        cellPadding: 3,
        lineWidth: 0,
        font: "NotoSansMono-Regular",
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "center" },
        2: { halign: "center" },
        3: { halign: "right" },
      },
      margin: { left: 8, right: 8 },
      didDrawCell: (data) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const left = 8;
        const right = pageWidth - 8;

        if (
          data.row.section === "head" &&
          data.row.index === 1 &&
          data.column.index === 3
        ) {
          const bottom = data.cell.y + data.cell.height + 2;
          doc.setLineDash([1, 1], 0);
          doc.setDrawColor(0);
          doc.line(left, bottom, right, bottom);
          doc.setLineDash([]);
        }
        if (
          data.row.section === "body" &&
          data.row.index === itemRows.length - 1 &&
          data.column.index === 0
        ) {
          const bottom = data.cell.y + data.cell.height + 2;
          doc.setLineDash([1, 1], 0);
          doc.setDrawColor(0);
          doc.line(left, bottom, right, bottom);
          doc.setLineDash([]);
        }
      },
    });

    y = doc.lastAutoTable.finalY + 18;
    y = checkPageBreak(doc, y);
    doc.setFontSize(14);
    doc.text(`Total Item: ${data.totalItems}`, 8, y);
    y += 24;
    doc.setFont("NotoSansMono-Bold", "bold").setFontSize(18);
    doc.text(
      `Total Amount: ₹${CurrencyConverter.toCurrency(
        data.grandtotal || 0,
        "INR"
      )}.00`,
      8,
      y
    );
    y += 12;

    doc.setLineDash([1, 1], 0);
    doc.line(10, y, pageWidth - 10, y);
    y += 18;
    y = checkPageBreak(doc, y);
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);
    if (parseFloat(data.totaldiscount) > 0) {
      doc.text("**** YOU SAVED ****", pageWidth / 2, y, { align: "center" });
      y += 16;
    }
    if (parseFloat(data.totaldiscount) > 0) {
      doc.text(
        `₹${CurrencyConverter.toCurrency(data.totaldiscount, "INR")}`,
        pageWidth / 2,
        y,
        { align: "center" }
      );
    }
    y += 18;
    y = checkPageBreak(doc, y);
    doc.setFontSize(14);
    doc.text("Thank you for your purchase!", pageWidth / 2, y, {
      align: "center",
    });
    y += 20;
    doc.setFont("NotoSansMono-Bold", "bold");
    doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
    if (storeSettings?.negobillBranding) {
      y += 20;
      doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);

      const payLabelX = 10;
      const payColonX = 125; // same column for all :
      const payValueX = 132; // amount starts just after :

      const drawPaymentRow = (label, amount, isBold = false) => {
        if (Number(amount) > 0) {
          y = checkPageBreak(doc, y);

          doc.setFont(
            isBold ? "NotoSansMono-Bold" : "NotoSansMono-Regular",
            isBold ? "bold" : "normal"
          );
          doc.setFontSize(14);

          doc.text(label, payLabelX, y);
          doc.text(":", payColonX, y);
          doc.text(
            `₹${CurrencyConverter.toCurrency(amount, "INR")}`,
            payValueX,
            y
          );

          y += 14;
        }
      };

      // ---------- PAYMENT MODE HEADER ----------
      doc.setLineDash([1, 1], 0);
      doc.line(8, y, pageWidth - 8, y);
      doc.setLineDash([]);
      y += 12;

      doc.setFont("NotoSansMono-Bold", "bold").setFontSize(14);
      doc.text("PAYMENT MODE", pageWidth / 2, y + 1, { align: "center" });
      y += 16;

      // ---------- PAYMENT VALUES ----------
      doc.setFont("NotoSansMono-Regular", "normal");

      // Adjusted values
      const cashPaid = (data.cashamount || 0) - (data.cashchange || 0);

      const cardPaid = (data.cardamount || 0) - (data.cardchange || 0);

      const onlinePaid = (data.onlineamount || 0) - (data.onlinechange || 0);

      const upiPaid = (data.upiamount || 0) - (data.upichange || 0);

      const balanceDue =
        (data.paylateramount || 0) - (data.paylaterchange || 0);

      // Draw only if value > 0
      drawPaymentRow("Cash", cashPaid);
      drawPaymentRow("Card", cardPaid);
      drawPaymentRow("Online Pay", onlinePaid);
      drawPaymentRow("UPI", upiPaid);

      // ---------- BALANCE DUE ----------
      if (balanceDue > 0) {
        y += 6;
        drawPaymentRow("Balance Due", balanceDue, true);
      }

      // ---------- FOOTER LINE ----------
      y += 4;
      doc.setLineDash([1, 1], 0);
      doc.line(8, y, pageWidth - 8, y);
      doc.setLineDash([]);
      y += 16;

      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text("Powered By", pageWidth / 2, y, { align: "center" });
      y += 18;

      doc.setFontSize(10);
      const sitePrefix = "www.";
      const siteBold = "NegoBill";
      const siteSuffix = ".com";
      const prefixWidth = doc.getTextWidth(sitePrefix);
      const boldWidth = doc.getTextWidth(siteBold);
      const suffixWidth = doc.getTextWidth(siteSuffix);
      const totalWidth = prefixWidth + boldWidth + suffixWidth;
      const startX = (pageWidth - totalWidth) / 2;

      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text(sitePrefix, startX, y);
      doc.setFont("NotoSansMono-Bold", "bold");
      doc.text(siteBold, startX + prefixWidth, y);
      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text(siteSuffix, startX + prefixWidth + boldWidth, y);
    }
    // setPrint(false);
    return doc;
  };

  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generate4InchBillReceipt();
    } else {
      doc = await generate3InchinvoiceReceipt();
    }

    const filenamePrefix = formatTrackMode(selectedSize)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generate4InchBillReceipt();
      } else {
        doc = await generate3InchinvoiceReceipt();
      }
      const pdfBase64 = doc.output("datauristring").split(",")[1];
      const response = await handlePrintSystem(pdfBase64, "TVS-E RP 3230");

      if (!response) {
        const blob = doc.output("blob");
        const blobUrl = URL.createObjectURL(blob);

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        iframe.src = blobUrl;
        document.body.appendChild(iframe);

        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }, 500);
        };
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPrint(false);
    }
  };

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);
  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS(
          "NotoSansMono_24pt-Regular-normal.ttf",
          NotoSansMonoReular
        );
        this.addFileToVFS(
          "NotoSansMono_24pt-Bold-normal.ttf",
          NotoSansMonoBold
        );
        this.addFont(
          "NotoSansMono_24pt-Regular-normal.ttf",
          "NotoSansMono-Regular",
          "normal"
        );
        this.addFont(
          "NotoSansMono_24pt-Bold-normal.ttf",
          "NotoSansMono-Bold",
          "bold"
        );
      },
    ]);
  }, []);

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);
  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  return (
    <>
      <div className="invoice-Thermalscale">
        {selectedSize === "INVOICE" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in row d-flex justify-content-center">
                  <div className={width ? "col-12" : "col-12"}>
                    <table width="100%" className="pdfcontent">
                      <tbody>
                        <tr>
                          <td width="100%" className="text-center">
                            <div className="tm_logo">
                              {("/assets/images/logo-light.png" ||
                                settings?.saleProfileData?.image) && (
                                <img
                                  src={
                                    settings?.saleProfileData?.image
                                      ? uRLs.IMAGE_URL +
                                        "profile/" +
                                        settings?.saleProfileData?.image
                                      : "/assets/images/logo-light.png"
                                  }
                                  className="img-rounded logo mb-0"
                                  height="40"
                                />
                              )}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="100%" className="text-center">
                            <div className="tm_primary_color fs-17 tm_text_uppercase mt-2">
                              {globalData?.salemode &&
                                formatTrackMode(globalData?.salemode)}
                            </div>
                            {globalData?.status === "CANCELLED" && (
                              <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                {globalData?.status}
                              </span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td className="text-center">
                            <div
                              style={{
                                fontSize: "17px",
                                fontWeight: "600",
                                marginBottom: "0px",
                              }}
                            >
                              {settings?.saleProfileData?.title || ""}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-center">
                            <div
                              style={{
                                fontSize: "13px",
                                lineHeight: "18px",
                                marginBottom: "0px",
                              }}
                            >
                              <div>
                                {settings?.saleProfileData?.addressline1 || ""}{" "}
                                {settings?.saleProfileData?.addressline2 || ""}{" "}
                                {settings?.saleProfileData?.district || ""}{" "}
                                {settings?.saleProfileData?.country || ""} -{" "}
                                {settings?.saleProfileData?.pincode || ""}
                              </div>
                              <div>
                                Phone: +91{" "}
                                {settings?.saleProfileData?.phone || ""}
                              </div>
                              <div>
                                Email: {settings?.saleProfileData?.email || ""}
                              </div>
                              {settings?.saleProfileData?.gstnumber && (
                                <div>
                                  GST:{" "}
                                  {settings?.saleProfileData?.gstnumber || ""}
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="tm_invoice_info tm_mb20 mt-2">
                      <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                    </div>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="40%" className="text-Start">
                            <div
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                marginBottom: "0px",
                              }}
                            >
                              Invoice No
                            </div>
                          </td>
                          <td width="10%" className="text-Start">
                            :
                          </td>
                          <td width="50%" className="text-Start">
                            <div
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                marginBottom: "0px",
                              }}
                            >
                              {globalData?.saleno}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="40%" className="text-Start">
                            <div
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                marginBottom: "0px",
                              }}
                            >
                              Date
                            </div>
                          </td>
                          <td width="10%" className="text-Start">
                            :
                          </td>
                          <td width="50%" className="text-Start">
                            <div
                              style={{
                                fontSize: "16px",
                                lineHeight: "22px",
                                marginBottom: "0px",
                              }}
                            >
                              {saleTime?.date}
                              {","}
                              {saleTime?.time}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="40%" className="text-Start">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                                marginBottom: "0px",
                              }}
                            >
                              Total Amount
                            </div>
                          </td>
                          <td width="10%" className="text-Start">
                            :
                          </td>
                          <td width="50%" className="text-Start mb-1">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                                marginBottom: "0px",
                              }}
                            >
                              ₹{globalData?.grandtotal}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="tm_invoice_info tm_mb20 mb-2">
                      <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                    </div>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="100%" className="text-center">
                            <div
                              style={{
                                fontSize: "17px",
                                fontWeight: "600",
                                marginBottom: "0px",
                              }}
                            >
                              BUYER INFORMATION
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="100%" style={{ verticalAlign: "top" }}>
                            {globalData?.saleto &&
                              (globalData?.saleto?.name ||
                                globalData?.saleto?.addressline1 ||
                                globalData?.saleto?.addressline2 ||
                                globalData?.saleto?.state ||
                                globalData?.saleto?.district ||
                                globalData?.saleto?.country ||
                                globalData?.saleto?.pincode ||
                                globalData?.saleto?.phone ||
                                globalData?.saleto?.email ||
                                globalData?.saleto?.gstnumber ||
                                globalData?.saleto?.statecode ||
                                globalData?.saleto?.referid) && (
                                <div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {globalData?.saleto?.name || ""}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "18px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    <div>
                                      {globalData?.saleto?.addressline1 || ""}{" "}
                                      {globalData?.saleto?.addressline2 || ""}{" "}
                                      {globalData?.saleto?.state || ""}{" "}
                                      {globalData?.saleto?.district || ""}{" "}
                                      {globalData?.saleto?.country || ""} -{" "}
                                      {globalData?.saleto?.pincode || ""}
                                    </div>
                                    {globalData?.saleto?.phone && (
                                      <div>
                                        Phone: +91 {globalData?.saleto?.phone}
                                      </div>
                                    )}
                                    {globalData?.saleto?.email && (
                                      <div>
                                        Email: {globalData?.saleto?.email}
                                      </div>
                                    )}
                                    {globalData?.saleto?.gstnumber && (
                                      <div>
                                        GST: {globalData?.saleto?.gstnumber}
                                      </div>
                                    )}
                                    {globalData?.saleto?.pannumber && (
                                      <div>
                                        PAN: {globalData?.saleto?.pannumber}
                                      </div>
                                    )}
                                    {globalData?.saleto?.cinnumber && (
                                      <div>
                                        CIN: {globalData?.saleto?.cinnumber}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="tm_invoice_info tm_mb20 my-2">
                      <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                    </div>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td colSpan={4} className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Items
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="10%"></td>

                          <td width="30%" className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Rate
                            </div>
                          </td>

                          <td width="30%" className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Qty
                            </div>
                          </td>

                          <td width="30%" className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Total
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <div className="tm_invoice_info tm_mb20 mt-2">
                              <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                            </div>
                          </td>
                        </tr>
                        {globalData?.saleitems?.map((product, index) => (
                          <>
                            <tr>
                              <td colSpan={4} className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "16px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  {product.title}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td width="10%"></td>

                              <td width="30%" className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "16px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  ₹{product?.soldprice}
                                </div>
                              </td>

                              <td width="30%" className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "16px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  {product?.quantity}{" "}
                                  {(() => {
                                    const unitCode = product?.isSecondaryUnit
                                      ? product?.unitConfig?.secondaryUnitCode
                                      : product?.unitConfig?.primaryUnitCode;
                                    return unitCode || "";
                                  })()}
                                </div>
                              </td>

                              <td width="30%" className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "16px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  ₹{product.lineTotalSoldPrice}
                                </div>
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </table>
                    <div className="tm_invoice_info tm_mb20 my-2">
                      <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                    </div>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="100%">
                            <div style={{ fontSize: "16px" }}>
                              Total Item : {globalData?.totalqty}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td width="100%">
                            <div
                              style={{ fontSize: "17px", fontWeight: "600" }}
                            >
                              Total Amount : ₹{globalData?.grandtotal}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="tm_invoice_info tm_mb20 my-2">
                      <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                    </div>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              fontSize: "17px",
                              textAlign: "center",
                              padding: "8px",
                              color: "black",
                            }}
                          >
                            ***** YOU SAVED *****
                            <div className="mt-1" style={{ fontSize: "17px" }}>
                              ₹{globalData?.totaldiscount}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="tm_invoice_info tm_mb20 my-2">
                      <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                    </div>
                    {Object.keys(taxRows || {})?.length > 0 && (
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "17px",
                                textAlign: "center",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Tax
                            </td>
                            <td
                              style={{
                                fontSize: "17px",
                                textAlign: "center",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Amount
                            </td>
                            {isIGST ? (
                              <td
                                style={{
                                  fontSize: "17px",
                                  textAlign: "center",
                                  padding: "8px",
                                  color: "black",
                                }}
                              >
                                IGST
                              </td>
                            ) : (
                              <>
                                {" "}
                                <td
                                  style={{
                                    fontSize: "17px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  SGST
                                </td>
                                <td
                                  style={{
                                    fontSize: "17px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  CGST
                                </td>
                              </>
                            )}
                          </tr>
                          {Object.entries(taxRows || {})
                            .filter(([percent]) => parseFloat(percent) > 0)
                            .map(([percent, t]) => (
                              <tr key={percent}>
                                <td
                                  style={{
                                    fontSize: "16px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  {percent}%
                                </td>
                                <td
                                  style={{
                                    fontSize: "16px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  ₹{t.basePrice}
                                </td>
                                {isIGST ? (
                                  <td
                                    style={{
                                      fontSize: "16px",
                                      textAlign: "center",
                                      padding: "8px",
                                      color: "black",
                                    }}
                                  >
                                    ₹{t.igst}
                                  </td>
                                ) : (
                                  <>
                                    <td
                                      style={{
                                        fontSize: "16px",
                                        textAlign: "center",
                                        padding: "8px",
                                        color: "black",
                                      }}
                                    >
                                      ₹{t.sgst}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "16px",
                                        textAlign: "center",
                                        padding: "8px",
                                        color: "black",
                                      }}
                                    >
                                      ₹{t.cgst}
                                    </td>
                                  </>
                                )}
                              </tr>
                            ))}
                          <tr>
                            <td colSpan={4}>
                              <div className="tm_invoice_info tm_mb20 mt-2">
                                <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colSpan={2}
                              style={{
                                fontSize: "16px",
                                textAlign: "left",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              TotalTax
                            </td>
                            <td
                              colSpan={2}
                              style={{
                                fontSize: "16px",
                                textAlign: "end",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.totaltaxamount}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                    <div className="tm_invoice_info tm_mb20 my-2">
                      <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                    </div>
                    <div
                      className="mt-1 text-center"
                      style={{ fontSize: "17px" }}
                    >
                      Thank you for your purchase
                    </div>
                    <div
                      className="mt-1 text-center"
                      style={{ fontSize: "17px", fontWeight: "600" }}
                    >
                      ** Visit us Again **
                    </div>

                    <table width="100%">
                      <tbody>
                        <tr>
                          <td colSpan={3}>
                            <div className="tm_invoice_info tm_mb20 my-2">
                              <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            colSpan={3}
                            className="text-center"
                            style={{
                              fontSize: "17px",
                              textAlign: "start",
                              padding: "8px",
                              color: "black",
                              fontWeight: "600",
                            }}
                          >
                            {" "}
                            PAYMENT MODE
                          </td>
                        </tr>
                        {globalData.cashPaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Cash
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.cashPaid}
                            </td>
                          </tr>
                        )}
                        {globalData.cardPaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Card
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.cardPaid}
                            </td>
                          </tr>
                        )}
                        {globalData.onlinePaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Online
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.onlinePaid}
                            </td>
                          </tr>
                        )}
                        {globalData.upiPaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              UPI
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.upiPaid}
                            </td>
                          </tr>
                        )}
                        {globalData.balanceDue > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              BalanceDue
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.balanceDue}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td colSpan={3}>
                            <div className="tm_invoice_info tm_mb20 my-2">
                              <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {storeSettings?.negobillBranding && (
                      <>
                        <div
                          className="mt-1 text-center"
                          style={{ fontSize: "17px" }}
                        >
                          Powered By
                        </div>
                        <div
                          className="mt-1 text-center"
                          style={{ fontSize: "15px", fontWeight: "600" }}
                        >
                          www.NegoBill.com
                        </div>
                      </>
                    )}
                    {/* {terms?.length > 0 && (
                  <table width="100%" style={{ marginLeft: "10px" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "8px",
                          }}
                        >
                          <div
                            className="fs-13 fw-600"
                            style={{
                              textAlign: "left",
                              color: "black",
                            }}
                          >
                            Terms & Conditions
                          </div>
                         
                          {terms}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : selectedSize === "BILL" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in">
                  <table width="100%" className="pdfcontent">
                    <tbody>
                      <tr>
                        <td width="100%" className="text-center">
                          <div className="tm_logo">
                            {("/assets/images/logo-light.png" ||
                              settings?.saleProfileData?.image) && (
                              <img
                                src={
                                  settings?.saleProfileData?.image
                                    ? uRLs.IMAGE_URL +
                                      "profile/" +
                                      settings?.saleProfileData?.image
                                    : "/assets/images/logo-light.png"
                                }
                                className="img-rounded logo mb-0"
                                height="50"
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="100%" className="text-center">
                          <div className="tm_primary_color fs-24 tm_text_uppercase mt-2">
                            {isViewData?.salemode &&
                              formatTrackMode(isViewData?.salemode)}
                          </div>
                          {isViewData?.status === "CANCELLED" && (
                            <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                              {isViewData?.status}
                            </span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <div
                            style={{
                              fontSize: "20px",
                              fontWeight: "600",
                              marginBottom: "0px",
                            }}
                          >
                            {settings?.saleProfileData?.title || ""}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <div
                            style={{
                              fontSize: "12px",
                              lineHeight: "18px",
                              marginBottom: "0px",
                            }}
                          >
                            <div>
                              {settings?.saleProfileData?.addressline1 || ""}{" "}
                              {settings?.saleProfileData?.addressline2 || ""}{" "}
                              {settings?.saleProfileData?.district || ""}{" "}
                              {settings?.saleProfileData?.country || ""} -{" "}
                              {settings?.saleProfileData?.pincode || ""}
                            </div>
                            <div>
                              Phone: +91{" "}
                              {settings?.saleProfileData?.phone || ""}
                            </div>
                            <div>
                              Email: {settings?.saleProfileData?.email || ""}
                            </div>
                            {settings?.saleProfileData?.gstnumber && (
                              <div>
                                <strong>GST:</strong>{" "}
                                {settings?.saleProfileData?.gstnumber || ""}
                              </div>
                            )}
                            {settings?.saleProfileData?.fssai && (
                              <div>
                                <strong>FSSAI:</strong>{" "}
                                {settings?.saleProfileData?.fssai}
                              </div>
                            )}
                            {settings?.saleProfileData?.pannumber && (
                              <div>
                                <strong>PAN:</strong>{" "}
                                {settings?.saleProfileData?.pannumber || ""}
                              </div>
                            )}
                            <div>
                              <strong>State:</strong>{" "}
                              {settings?.saleProfileData?.state || ""} [ State
                              Code :{settings?.saleProfileData?.statecode || ""}{" "}
                              ]
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="tm_invoice_info tm_mb20 mt-2">
                    <div
                      className="tm_invoice_seperator1 tm_gray_bg_dark"
                      style={{
                        backgroundColor:
                          selectedTheme?.templateTheme?.primaryColor,
                      }}
                    ></div>
                  </div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="40%" className="text-Start">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              marginBottom: "0px",
                            }}
                          >
                            Bill No
                          </div>
                        </td>
                        <td width="20%" className="text-Start">
                          :
                        </td>
                        <td width="40%" className="text-Start">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              marginBottom: "0px",
                            }}
                          >
                            {isViewData?.saleno}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="40%" className="text-Start">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              marginBottom: "0px",
                            }}
                          >
                            Date
                          </div>
                        </td>
                        <td width="20%" className="text-Start">
                          :
                        </td>
                        <td width="40%" className="text-Start">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              marginBottom: "0px",
                            }}
                          >
                            {saleTime?.date}
                            {","}
                            {saleTime?.time}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="40%" className="text-Start">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              fontWeight: "600",
                              marginBottom: "0px",
                            }}
                          >
                            Total Amount
                          </div>
                        </td>
                        <td width="20%" className="text-Start">
                          :
                        </td>
                        <td width="40%" className="text-Start mb-1">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              fontWeight: "600",
                              marginBottom: "0px",
                            }}
                          >
                            ₹
                            {CurrencyConverter.toCurrency(
                              isViewData?.grandtotal || 0,
                              "INR"
                            )}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="tm_invoice_info tm_mb20 mb-2">
                    <div
                      className="tm_invoice_seperator1 tm_gray_bg_dark"
                      style={{
                        backgroundColor:
                          selectedTheme?.templateTheme?.primaryColor,
                      }}
                    ></div>
                  </div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="100%" className="text-center">
                          <div
                            style={{
                              fontSize: "20px",
                              fontWeight: "600",
                              marginBottom: "0px",
                            }}
                          >
                            BUYER INFORMATION
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="100%" style={{ verticalAlign: "top" }}>
                          {isViewData?.saleto &&
                            (isViewData?.saleto?.name ||
                              isViewData?.saleto?.addressline1 ||
                              isViewData?.saleto?.addressline2 ||
                              isViewData?.saleto?.state ||
                              isViewData?.saleto?.district ||
                              isViewData?.saleto?.country ||
                              isViewData?.saleto?.pincode ||
                              isViewData?.saleto?.phone ||
                              isViewData?.saleto?.email ||
                              isViewData?.saleto?.gstnumber ||
                              isViewData?.saleto?.statecode ||
                              isViewData?.saleto?.referid) && (
                              <div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    marginBottom: "0px",
                                  }}
                                >
                                  {isViewData?.saleto?.name || ""}
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    lineHeight: "18px",
                                    marginBottom: "0px",
                                  }}
                                >
                                  {isViewData?.saleto?.phone && (
                                    <div>
                                      Phone: +91 {isViewData?.saleto?.phone}
                                    </div>
                                  )}
                                  <div>
                                    {isViewData?.saleto?.addressline1 || ""}{" "}
                                    {isViewData?.saleto?.addressline2 || ""}{" "}
                                  </div>
                                </div>
                              </div>
                            )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="tm_invoice_info tm_mb20 my-2">
                    <div
                      className="tm_invoice_seperator1 tm_gray_bg_dark"
                      style={{
                        backgroundColor:
                          selectedTheme?.templateTheme?.primaryColor,
                      }}
                    ></div>
                  </div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td colSpan={4} className="text-start mb-1">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              fontWeight: "600",
                            }}
                          >
                            Items
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td width="10%"></td>

                        <td width="30%" className="text-start mb-1">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              fontWeight: "600",
                            }}
                          >
                            Rate
                          </div>
                        </td>

                        <td width="30%" className="text-start mb-1">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              fontWeight: "600",
                            }}
                          >
                            Qty
                          </div>
                        </td>

                        <td width="30%" className="text-start mb-1">
                          <div
                            style={{
                              fontSize: "20px",
                              lineHeight: "22px",
                              fontWeight: "600",
                            }}
                          >
                            Total
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={4}>
                          <div className="tm_invoice_info tm_mb20 mt-2">
                            <div
                              className="tm_invoice_seperator1 tm_gray_bg_dark"
                              style={{
                                backgroundColor:
                                  selectedTheme?.templateTheme?.primaryColor,
                              }}
                            ></div>
                          </div>
                        </td>
                      </tr>
                      {isViewData?.saleitems?.map((product, index) => (
                        <>
                          <tr>
                            <td colSpan={4} className="text-start mb-1">
                              <div
                                style={{
                                  fontSize: "18px",
                                  lineHeight: "22px",
                                }}
                              >
                                {product.title}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td width="10%"></td>

                            <td width="30%" className="text-start mb-1">
                              <div
                                style={{
                                  fontSize: "18px",
                                  lineHeight: "22px",
                                }}
                              >
                                ₹
                                {CurrencyConverter.toCurrency(
                                  product?.soldprice || 0,
                                  "INR"
                                )}
                              </div>
                            </td>

                            <td width="30%" className="text-start mb-1">
                              <div
                                style={{
                                  fontSize: "18px",
                                  lineHeight: "22px",
                                }}
                              >
                                {product?.quantity}
                              </div>
                            </td>

                            <td width="30%" className="text-start mb-1">
                              <div
                                style={{
                                  fontSize: "18px",
                                  lineHeight: "22px",
                                }}
                              >
                                ₹
                                {CurrencyConverter.toCurrency(
                                  product.lineTotalSoldPrice || 0,
                                  "INR"
                                )}
                              </div>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                  <div className="tm_invoice_info tm_mb20 my-2">
                    <div
                      className="tm_invoice_seperator1 tm_gray_bg_dark"
                      style={{
                        backgroundColor:
                          selectedTheme?.templateTheme?.primaryColor,
                      }}
                    ></div>
                  </div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="100%">
                          <div style={{ fontSize: "18px" }}>
                            Total Item : {isViewData?.totalqty}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td width="100%">
                          <div style={{ fontSize: "20px", fontWeight: "600" }}>
                            Total Amount :{" "}
                            {CurrencyConverter.toCurrency(
                              isViewData?.grandtotal || 0,
                              "INR"
                            )}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="tm_invoice_info tm_mb20 my-2">
                    <div
                      className="tm_invoice_seperator1 tm_gray_bg_dark"
                      style={{
                        backgroundColor:
                          selectedTheme?.templateTheme?.primaryColor,
                      }}
                    ></div>
                  </div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td
                          style={{
                            fontSize: "20px",
                            textAlign: "center",
                            padding: "8px",
                            color: "black",
                          }}
                        >
                          ***** YOU SAVED *****
                          <div className="mt-1" style={{ fontSize: "20px" }}>
                            ₹
                            {CurrencyConverter.toCurrency(
                              isViewData?.totaldiscount || 0,
                              "INR"
                            )}
                          </div>
                          <div className="mt-1 " style={{ fontSize: "20px" }}>
                            Thank you for your purchase
                          </div>
                          <div
                            className="mt-1"
                            style={{ fontSize: "20px", fontWeight: "600" }}
                          >
                            ** Visit us Again **
                          </div>
                          {storeSettings?.negobillBranding && (
                            <>
                              <div
                                className="mt-1"
                                style={{ fontSize: "20px" }}
                              >
                                Powered By
                              </div>
                              <div
                                className="mt-1"
                                style={{ fontSize: "18x", fontWeight: "600" }}
                              >
                                www.NegoBill.com
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {terms?.length > 0 && (
                    <table width="100%" style={{ marginLeft: "10px" }}>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              padding: "8px",
                            }}
                          >
                            <div
                              className="fs-13 fw-600"
                              style={{
                                textAlign: "left",
                                color: "black",
                              }}
                            >
                              Terms & Conditions
                            </div>
                            {/* {terms.map((item, index) => (
                            <div className="mt-1 fs-20 ms-4">
                              {index + 1}
                              {"."}
                              {item}
                            </div>
                          ))} */}
                            {terms}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>

      {downloadbtn && (
        <div
          className="modal-footer d-block mt-2"
          style={{
            width: "180%",
            position: "sticky",
            bottom: -4,
            background: "#fff",
            zIndex: 10,
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <div className=" d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"fs-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={12} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Thermal_1;
